export const PLAYLIST_CARD_DRAWER_WIDTH = 364;
export const PLAYLIST_CARD_LIST_VIEW_WIDTH = 408;
export const PLAYLIST_SKELETON_HEIGHT = 180;

export const SUGGESTED_PLAYLIST_CARD_WIDTH = 286;
export const SUGGESTED_PLAYLIST_CARD_IMAGE_HEIGHT = 200;

export const DRAWER_MAX_WIDTH = 412;

export const TASK_CARD_MIN_WIDTH = 364;
export const TASK_CARD_MIN_HEIGHT = 180;
